import { setErrorDialog, serverUrl, getheader, translateError, cacheTypes, getMethodByCallBack, getMethodByDispatcher, postMethodByCallBack, postMethodByDispatcher } from "../../../store/api/CommonFunctions";


export function getAgentList(data) {
    if (!data) {
        data = {};
    }
    return dispatch => {
        dispatch({
            type: "GET_AGENT_LIST",
            data: "PENDING"
        });
        fetch(serverUrl + "api/StaffAPI/GetAgentList", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST"

        }).then(res => res.json())
            .then(res => {
                if (res.Message === "Error") {
                    res = null;
                }
                dispatch({
                    type: "GET_AGENT_LIST",
                    data: res
                })
            }).catch(err => {
                dispatch({
                    type: "GET_AGENT_LIST",
                    data: null
                });
                console.log("[GET_AGENCT_LIST]", err)
            })
    }
}
export function getMiddlemanList(data) {
    if (!data) {
        data = {};
    }
    return dispatch => {
        dispatch({
            type: "GET_MIDDLEMAN_LIST",
            data: "PENDING"
        });
        fetch(serverUrl + "api/StaffAPI/GetMiddlemanList", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST",
            cache: "default"

        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "لیست معرف")
                    res = null;
                }
                dispatch({
                    type: "GET_MIDDLEMAN_LIST",
                    data: res
                })
            }).catch(err => {
                dispatch({
                    type: "GET_MIDDLEMAN_LIST",
                    data: null
                });
                console.log("[GET_MIDDLEMAN_LIST]", err)
            })
    }
}
export function getRelatedStaffsToAgent(data) {
    if (!data) {
        data = {};
    }
    return dispatch => {
        dispatch({
            type: "GET_RELATEDSTAFFS",
            data: "PENDING"
        });
        fetch(serverUrl + "api/StaffAPI/GetRelatedStaffsToAgent", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST",
            cache: "no-cache"

        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "دریافت اطلاعات");
                    res = null;
                }
                dispatch({
                    type: "GET_RELATEDSTAFFS",
                    data: res
                })
            }).catch(err => {
                dispatch({
                    type: "GET_RELATEDSTAFFS",
                    data: null
                });
                console.log("[GetRelatedStaffsForAgent]", err)
            })
    }
}
export function getStaffList4Modal(staffType, data, onGetData) {
    onGetData("PENDING");
    if (!data) {
        data = {};
    }
    const apiName = staffType === "agency" ? "GetAgentList" :
        staffType === "middleman" ? "GetMiddlemanList" :
            staffType === "staff" ? "GetRelatedStaffsToAgent" : "GetPersonnelList";

    fetch(serverUrl + "api/StaffAPI/" + apiName, {
        headers: getheader(),
        body:JSON.stringify(data),
        method:"POST"
    }).then(res=>res.json())
        .then(res=>{
            if(res.Message)
            {
                onGetData({Error:translateError(res.Message)});
                return;
            }
            onGetData(res);
        }).catch(e=>{
            console.log("[GET_STAFF_MODAL]",e);
            onGetData({Error:"Error"});
        })
}
export function attachFile(fileInput, parentID, attachmentType, fn, moreInfo, nameIsUnique) {
    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
        return;
    }
    var formdata = new FormData();
    for (let i = 0; i < fileInput.files.length; i++) {
        formdata.append(fileInput.files[i].name, fileInput.files[i]);
        formdata.append("ParentID", parentID);
        formdata.append("AttachmentType", attachmentType);
    }
    if (moreInfo) {
        formdata.append("moreInfo", moreInfo);
    }
    var xhr = new XMLHttpRequest();
    xhr.open('POST', serverUrl + 'api/Attachments/Upload', true);
    xhr.setRequestHeader("token", localStorage.getItem("token"));
    if (nameIsUnique) {
        xhr.setRequestHeader("NameIsUniq", nameIsUnique);
    }
    xhr.send(formdata);
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            var response = JSON.parse(xhr.responseText);
            if (response.Message !== "Error") {
                alert("بارگذاری با موفقیت انجام شد");
                if (fn)
                    fn();
            }
            else {
                alert("اشکال در آپلود فایل");
            }

        }
        return "UnExpected Error";

    };
}
export function downloadFile(itemID, attachmentType) {
    //window.open(serverUrl + `api/Attachments/DownloadAttachment?id=${itemID}&attachmentType=${attachmentType}`, "download");
    fetch(serverUrl + `api/Attachments/DownloadAttachment?id=${itemID}&attachmentType=${attachmentType}`,
    {
      headers: {
        'Content-Type': 'blob',
        'token': localStorage.getItem("token")
      }
      , method: "get"
    })
    .then((response) => {
      response.blob()
        .then((blob) => {
          if(blob.type ==="application/json")
          {
            return;
          }
          var a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.download = "Download";
          a.click();
        })
    })    
}
export function deleteAttachment(id, type, onSuccess) {
    return dispatch => {
        fetch(serverUrl + `api/Attachments/DeleteAttachment?id=${id}&attachmentType=${type}`, {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res === "Success") {
                    setErrorDialog(dispatch, "success", "حذف پیوست");
                    if (onSuccess) {
                        onSuccess();
                    }
                }
                else {
                    setErrorDialog(dispatch, "Error", "حذف پیوست");
                    return dispatch({
                        type: "DELETE_ATTACHMENT",
                        data: "ERROR"
                    });
                }
            }).catch(e => {
                console.log("[DELETE_ATTACHMENT]", e);
            })
    }
}
export function getStaffLastCode(onGetCode) {
    getMethodByCallBack(`api/StaffAPI/GetStaffLastCode`, cacheTypes.NoCache, onGetCode, "GetStaffLastCode");
}
export function addOrUpdateStaff(data, onPost) {
    postMethodByCallBack(`api/StaffAPI/AddOrUpdateStaff`, data, onPost, "AddOrUpdateStaff")
}
export function getStaff(id, onGet) {
    getMethodByCallBack(`api/StaffAPI/GetStaffByID?Id=${id}`, cacheTypes.NoCache, onGet, "GetStaffByID");
}
export function getStaffAttachments(staffID) {
    return dispatch => dispatch(getMethodByDispatcher(`api/Attachments/GetAttachmentList?parentID=${staffID}&attachmentType=Staff`, "GET_STAFF_ATTACHMENTS", cacheTypes.NoCache, "دریافت پیوست ها"));
}
export function getStaffAutoSendData(staffID, onGet) {
    getMethodByCallBack(`api/StaffAPI/GetStaffAutoSendData?staffID=${staffID}`, cacheTypes.NoCache, onGet, "GetStaffAutoSendData")
}
export function updateStaffAutoSendData(data, onUpdate) {
    postMethodByCallBack(`api/StaffAPI/UpdateStaffAutoSendData`, data, onUpdate, "UpdateStaffAutoSendData");
}
export function searchStaff(data, onSearch) {
    return dispatch => {
        dispatch({
            type: "STAFF_SEARCH_FILTERS",
            data: data
        })
        dispatch(postMethodByDispatcher("api/StaffAPI/SearchStaff", data, "SEARCH_STAFF", "جستجوی نماینده/تکنسین", onSearch));
    }
}
/**
 * 
 * @param {object} data 
 * @param {function} onGet 
 */
export function getStaffMobilesByFilter(data, onGet)
{
    postMethodByCallBack("api/StaffAPI/GetStaffMobilesByFilter", data, onGet, "GET_STAFF_MOBILES");
}
export function deleteStaff(id, onDelete) {
    return dispatch => {
        const onSuccess=(res)=>{
            if(!res.Error && res !=="PENDING")
            {
                setErrorDialog(dispatch,"success","حذف تکنسین/نماینده");
                onDelete(res);
            }
            else if(res.Error)
            {
                setErrorDialog(dispatch, res.Error,"حذف تکنسین/نماینده");
            }           
        }
        getMethodByCallBack(`api/StaffAPI/DeleteStaff?Id=${id}`, cacheTypes.NoCache, onSuccess, "DeleteStaff");
    }
}